/* globals GIG */

'use strict';

const Gift = require('../../gift_button/frontend/gift');

const MultiOptionModal = {};

MultiOptionModal.init = function(payload) {
  if (!(payload != null ? payload.buyButton.multiOptionEnabled : undefined)) {
    return null;
  }

  const $modal = $('#options');
  if ($modal.length && $modal.hasClass('tooltip')) {
    const $tooltipTriggers = $('.gift-button, .buy-button');
    $tooltipTriggers.attr('href', '#options');

    $modal.on('click', '.tooltip-close', Gift.removeCookie);
  }

  const openMultiOptionModal = function(e) {
    if (e != null) {
      e.preventDefault();
    }
    if (!$modal.length) {
      return null;
    }
    if ($modal.hasClass('tooltip')) {
      const $tooltipTrigger = Gift.cookieCreated
        ? $('.gift-button')
        : $('.buy-button');

      if ($tooltipTrigger.hasClass('tippy-active')) {
        return { stopTheBus: true };
      }

      const $triggers = $('.gift-button, .buy-button');
      $triggers
        .removeClass('tooltip-trigger')
        .attr('data-tooltip-id', null)
        .attr('data-tippy-config', null);

      window.GIG.Tooltip.destroy('.buy-button');
      window.GIG.Tooltip.destroy('.gift-button');

      const tooltipConfig = {
        id: 'options',
        config: {
          flip: false,
          trigger: 'click',
          interactive: true,
          maxWidth: 572,
          placement: 'bottom-right',
        },
      };

      $tooltipTrigger.attr('data-tooltip-id', tooltipConfig.id);
      $tooltipTrigger.attr(
        'data-tippy-config',
        JSON.stringify(tooltipConfig.config)
      );

      $tooltipTrigger.addClass('tooltip-trigger');

      GIG.Tooltip.init($tooltipTrigger, {
        onHidden: () => Gift.removeCookie(),
        onShown: () => {
          const $tooltipCloser = $('.tooltip-close.icon-x');
          if ($tooltipCloser.length > 0) {
            $tooltipCloser.off('click');
            $tooltipCloser.on('click', () =>
              GIG.Tooltip.close(
                Gift.cookieCreated
                  ? document.querySelector('.gift-button')
                  : document.querySelector('.buy-button')
              )
            );
          }
        },
      });

      GIG.Tooltip.open($tooltipTrigger);
    } else {
      if ($modal.hasClass('show-modal')) {
        return null;
      }
      if ($('.header-row-sticky').is(':visible')) {
        return null;
      }

      if (!window.BuyButton.view.$multiOptions.filter('.selected').length) {
        const options = window.BuyButton.view.$multiOptions;
        let cheapestOption = null;
        for (const option of Array.from(options)) {
          if (
            !option.disabled &&
            (!cheapestOption ||
              parseInt(option.dataset.amount) <
                parseInt(cheapestOption.dataset.amount))
          ) {
            cheapestOption = option;
          }
        }

        if (!cheapestOption) {
          cheapestOption = window.BuyButton.view.$multiOptions.not(
            ':disabled'
          )[0];
        }

        window.BuyButton.view.updateMultiOptionBreakoutButton({
          currentTarget: cheapestOption,
        });
      }

      GIG.Modal.open({ el: $modal });
    }

    return { stopTheBus: true };
  };

  window.BuyButton.eventBus.board(
    'buy_button_clicked',
    openMultiOptionModal
  )(998);

  GIG.Modal.onClose(Gift.removeCookie, 'options');

  return null;
};

window.MultiOptionModal = MultiOptionModal;
module.exports = MultiOptionModal;
